import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

// import ui_home from '../components/ui-pages/ui-home.vue'
import ui_color from '../components/ui-pages/ui-color.vue'
import ui_button from '../components/ui-pages/ui-button.vue'
import ui_typography from '../components/ui-pages/ui-typography.vue'
import ui_layout from '../components/ui-pages/ui-layout.vue'
// import ui_icons from '../components/ui-pages/icons.vue'
// import ui_switch from '../components/ui-pages/ui-switch.vue'
import ui_radio from '../components/ui-pages/ui-radio.vue'
import ui_checkbox from '../components/ui-pages/ui-checkbox.vue'
// import ui_input from '../components/ui-pages/ui-input.vue'
// import ui_dropdown from '../components/ui-pages/ui-dropdown.vue'
// import ui_tables from '../components/ui-pages/ui-tables.vue'
import ui_tag from '../components/ui-pages/ui-tag.vue'
// import ui_progress from '../components/ui-pages/ui-progress.vue'
import ui_alert from '../components/ui-pages/ui-alert.vue'
// import ui_tooltip from '../components/ui-pages/ui-tooltip.vue'
// import ui_modal from '../components/ui-pages/ui-modal.vue'

let router = new VueRouter({
    mode: 'history',
    routes: [
        // {path: '/', component: ui_home},
        {path: '/ui-color', component: ui_color},
        {path: '/ui-button', component: ui_button},
        {path: '/ui-typography', component: ui_typography},
        {path: '/ui-layout', component: ui_layout},
        // {path: '/ui-icons', component: ui_icons},
        {path: '/ui-alert', component: ui_alert},
        {path: '/ui-radio', component: ui_radio},
        {path: '/ui-checkbox', component: ui_checkbox},
        // {path: '/ui-input', component: ui_input},
        // {path: '/ui-dropdown', component: ui_dropdown},
        // {path: '/ui-tables', component: ui_tables},
        {path: '/ui-tag', component: ui_tag},
        // {path: '/ui-progress', component: ui_progress},
        // {path: '/ui-switch', component: ui_switch},
        // {path: '/ui-tooltip', component: ui_tooltip},
        // {path: '/ui-modal', component: ui_modal},
    ]
});
if(document.getElementById('ui-page')){
    new Vue({
        name: 'ui',
        el: '#ui-page',
        router: router,
        data: {
            activeIndex: '',
            test: 'fwfww',
        },
        methods: {},
        components: {
            ui_color,
        },
        created() {},
        mounted() {

        }
    });
}
